import {Component, OnInit} from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {ReactiveFormsModule} from '@angular/forms';
import {NzAlertModule} from 'ng-zorro-antd/alert';

@Component({
  selector: 'zorrly-agree',
  standalone: true,
  imports: [
    CommonModule,
    NzCheckboxModule,
    ReactiveFormsModule,
    NzAlertModule,
    FormlyModule
  ],
  template: `
      <div [style.margin]="'10px 0'" [style]="props.style">
          <label nz-checkbox [formControl]="$any(formControl)">{{props.label}}</label>
      </div>
      <div *ngIf="formControl.dirty && formControl.errors" class="ant-form-item-explain-error">
          <formly-validation-message [field]="field"></formly-validation-message>
      </div>
  `,
})
export class ZorrlyAgreeComponent extends FieldType implements OnInit {

  ngOnInit(): void {

  }
}
